// Web module: access-reviews (people lane). Access Review list (active review, completed reviews, start a review) and
// the review page (applications, reviewers, accounts, bulk status, completion, re-open). The contract is in ../README.md.
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    access_review: {
      ListPage: lazyComponent(() => import('./AccessReviewsListPage'), 'AccessReviewsListPage'),
      DetailPage: lazyComponent(() => import('./AccessReviewDetailPage'), 'AccessReviewDetailPage'),
    },
  },
}
